module.exports = __webpack_public_path__ + "assets/img/doctordetails-noData.0b45e807.png";